import React from 'react';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import { MatField } from 'src/core/components/mat-field';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as Styles from './residence-information.less';
import * as Utils from '../../forms/application-information-forms-utils';
import { ResidenceForm } from '../../forms/application-information-forms';

interface IResidenceInformationProps {
    residence: ResidenceForm;
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}

export const ResidenceInformation: React.FC<IResidenceInformationProps> = observer(
    ({ residence, validate }) => {
        return (
            <>
                <div className={Styles.row}>
                    <div className={Styles.nestedCol}>
                        <div className={Styles.sectionTitle}>Do you own or rent? *</div>
                    </div>
                    <div className={Styles.nestedCol}>
                        <div className={Styles.sectionTitle}>Property Type *</div>
                    </div>
                </div>
                <div className={Styles.row}>
                    <div className={Styles.col}>
                        <RadioGroup
                            row
                            value={residence.$.HousingType.value}
                            onChange={(e, val) => residence.$.HousingType.onChange(val)}
                        >
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="Own"
                                control={<Radio className={Styles.radio} />}
                                label="Own"
                            />
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="Rent"
                                control={<Radio className={Styles.radio} />}
                                label="Rent"
                            />
                        </RadioGroup>
                    </div>
                    <div className={Styles.residenceCol}>
                        <RadioGroup
                            row
                            value={residence.$.PropertyType.value}
                            onChange={(e, val) => residence.$.PropertyType.onChange(val)}
                        >
                            <FormControlLabel
                                value="Single Family"
                                control={<Radio className={Styles.radio} />}
                                label="Single Family"
                            />
                            <FormControlLabel
                                value="Manufactured Home"
                                control={<Radio className={Styles.radio} />}
                                label="Manufactured Home"
                            />
                        </RadioGroup>
                    </div>
                </div>
                {residence.$.HousingType.value && (
                    <div className={Styles.fadeIn}>
                        <div className={Styles.row}>
                            <div className={Styles.col}>
                                <MatField
                                    required
                                    fullWidth
                                    errorColor
                                    fieldState={residence.$.MonthlyPayment}
                                    maxLength={26}
                                    formatter={Utils.formatAmount}
                                    validator={Utils.amountValidator}
                                    label={
                                        residence.$.HousingType.value === 'Own'
                                            ? 'Monthly Mortgage Amount ($)'
                                            : 'Rental Amount ($)'
                                    }
                                    startAdornment="$"
                                    onBlur={validate(residence.$.MonthlyPayment)}
                                />
                            </div>
                            <div className={Styles.col}></div>
                        </div>
                    </div>
                )}
            </>
        );
    }
);
